import { render, staticRenderFns } from "./Gravacoes.vue?vue&type=template&id=6bf5e59e"
import script from "./Gravacoes.vue?vue&type=script&lang=js"
export * from "./Gravacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports